import { useEffect, type RefObject } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Page title from the page's h1 (SC 2.4.2): "<heading> · Tibyan". Runs after every render so a heading that
 * changes (loaded course name, language switch) keeps the tab title and screen-reader announcement in step.
 */
export function useDocumentTitle(heading: RefObject<HTMLElement | null>): void {
  const { t } = useTranslation('common');
  const brand = t('brand.name');
  useEffect(() => {
    const text = heading.current?.textContent?.replace(/\s+/g, ' ').trim();
    const next = text ? `${text} · ${brand}` : brand;
    if (document.title !== next) document.title = next;
  });
}
